<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import http from '@/http/index';

export default {
  name: 'App',
  created () {
    // 默认兜底图片
    const DEFAULT_BANNER = require('@/assets/images/logo.png');

    // 1. 优先从路由 query 获取 abbr
    const queryAbbr = this.$route.query.abbr;

    // 2. 如果 query 有 abbr，更新 localStorage
    if (queryAbbr) {
      window.localStorage.setItem('pcs_org_abbr', queryAbbr);
      window.localStorage.removeItem('logoUrl'); // 清除旧缓存
    }

    // 3. 从 localStorage 获取 abbr
    const storedAbbr = window.localStorage.getItem('pcs_org_abbr');

    // 4. 如果已有 logoUrl 缓存，直接使用（避免重复请求）
    const cachedLogo = window.localStorage.getItem('logoUrl');
    if (cachedLogo) {
      this.$store.state.logoUrl = cachedLogo;
      return;
    }

    // 5. 如果 abbr 无效，直接使用默认图片
    if (!storedAbbr || typeof storedAbbr !== 'string' || storedAbbr.trim() === '') {
      this.$store.state.logoUrl = DEFAULT_BANNER;
      window.localStorage.setItem('logoUrl', DEFAULT_BANNER);
      return;
    }

    // 6. abbr 有效，发起请求
    http.getBannerImg({ abbr: storedAbbr.trim() })
      .then(res => {
        // 安全校验响应结构
        if (res.data.data) {
          const data = res.data.data;

          // 设置机构名称（可选）
          if (data.orgName) {
            this.$store.state.name = data.orgName;
          }

          // 优先使用返回的第一张图，否则用默认图
          const imageUrl = (Array.isArray(data.imageUrlList) && data.imageUrlList[0])
            ? data.imageUrlList[0]
            : DEFAULT_BANNER;

          this.$store.state.logoUrl = imageUrl;
          window.localStorage.setItem('logoUrl', imageUrl);
        } else {
          // 接口返回无数据，用默认图
          this.$store.state.logoUrl = DEFAULT_BANNER;
          window.localStorage.setItem('logoUrl', DEFAULT_BANNER);
        }
      })
      .catch(err => {
        console.warn('获取 Banner 图片失败:', err);
        // 请求出错，兜底用本地图片
        this.$store.state.logoUrl = DEFAULT_BANNER;
        window.localStorage.setItem('logoUrl', DEFAULT_BANNER);
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue